"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useMessageBarBody_unstable", {
    enumerable: true,
    get: function() {
        return useMessageBarBody_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactutilities = require("@fluentui/react-utilities");
const _messageBarContext = require("../../contexts/messageBarContext");
const useMessageBarBody_unstable = (props, ref)=>{
    const { bodyRef } = (0, _messageBarContext.useMessageBarContext)();
    return {
        components: {
            root: 'div'
        },
        root: _reactutilities.slot.always((0, _reactutilities.getIntrinsicElementProps)('div', {
            ref: (0, _reactutilities.useMergedRefs)(ref, bodyRef),
            ...props
        }), {
            elementType: 'div'
        })
    };
};
